<template>

	<body>
		<div>
			<div class="bannerWrap">
				<div class="banner">
					<img src="../assets/2015100910563038.jpg" alt='' title='' />
				</div>
				<div class="bannerText">
					<img src="../assets/2018070417064416.png" alt title />
				</div>
			</div>
			<div class="mainWrap">
				<div class="main">
					<div class="breadCrumbs">
						<h3>{{product.name}}</h3>
						<span>
                <a >首页</a> &gt;
                <a @click="product()">产品</a> &gt;
                <em>{{product.name}}</em>
            </span>
					</div>
					<!--内容开始-->
					<div class="content">
						<div class="product">
							<div id="spanDiv">

								<dl>
									<dt>
									 <img :src="product.image"/>
									
									</dt>
									<dd>
										<p class="crXinghao">{{product.titel}}</p>
										<h3>{{product.detail}}</h3>
										<p class="desc"></p>
										<span>{{product.price}}</span>
									 <div class="bt">
                            	<a data-pid="30" @click="purchase()">立即购买</a>
                            	<a href="/Product/30.html">了解更多</a>
                           </div>
									</dd>
									<div class="clearfix"></div>
								</dl>

							</div>
							<div class="product_bottom">
								<a id="linkGengDuo" href="javascript:;" page="1" pid="68">
									<span class="icon"></span>
									<i>查看更多产品</i>
								</a>
							</div>
						</div>
					</div>
					<!--内容结束-->
				</div>
			</div>

		</div>
	</body>
</template>

<script>


    export default {
        data(){
            return {
                
                product: {
                	

					id: 1,
					name: '限量版耳机（1LE）',
					titel:'1LE',
					price:'￥1680.00',
					image: require('../assets/2016120817393507.png'),
					detail:' 1周年限量版（已售罄）'
				}
            }
        },
        methods: {
           
            purchase() {

				this.$router.push('/login')

			}
        },
        mounted(){
           
        }
    }
</script>


<style scoped>
	@import '../../static/newlayout.css';
</style>


// WEBPACK FOOTER //
// src/views/LimitedVersion.vue